import MicroModal from 'micromodal';

const hasClosedMobileWarningModalKey = 'has-closed-mobile-warning-modal-key';

// Run the functions on document ready
document.addEventListener('DOMContentLoaded', () => {
    MicroModal.init();

    const scrollModalContainerToTop = (modalId: string) => {
        const modalContainer = document.querySelector(`#${modalId} .modal-container`);
        if (modalContainer) {
            modalContainer.scrollTop = 0;
        }
    };

    if (window.matchMedia('only screen and (max-width: 768px)').matches) {
        const hasClosedMobileWarningModal = sessionStorage.getItem(hasClosedMobileWarningModalKey);
        if (!hasClosedMobileWarningModal) {
            const triggerMobile = document.getElementById('mobile-warning-modal-trigger');
            if (triggerMobile) {
                triggerMobile.click();
                (document.activeElement as HTMLElement).blur();
            }
        }
    }

    const modalBtns = document.querySelectorAll('button[data-micromodal-trigger]');

    modalBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const modalId = btn.getAttribute('data-micromodal-trigger');
            if (modalId) {
                scrollModalContainerToTop(modalId);
            }
        });
    });
});

document.addEventListener('click', event => {
    const clickedElement = event.target as Element;
    // If the clicked element doesn't have the right selector, bail
    if (!clickedElement.matches('.modal .modal-mobile-warning-btn')) {
        return;
    }

    sessionStorage.setItem(hasClosedMobileWarningModalKey, 'warning-closed');
    const parentModalOverlay = clickedElement.closest('.modal-overlay');
    if (parentModalOverlay) {
        (parentModalOverlay as HTMLElement).click();
    }
});
